module.exports = __webpack_public_path__ + "img/shouyi.3f31dd76.png";